import dayjs from "dayjs";
import nowTimeMixin from "@/mixins/nowTime.js";
export default {
  mixins: [nowTimeMixin]
};